module.exports = {
    pcaa: require('./area-vue')
};



// WEBPACK FOOTER //
// ./src/components/common/area-data-vue/data.js